import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { StorageLineID, StorageTokenJWT } from "../../app_services/StorageService";
// import { get_main_user_data } from "../../page_action/app_main";
import Context from '../../app_context/Context';
import { Helmet } from 'react-helmet';
import liff from '@line/liff';

import { Loading, AlertError, AlertInfo, AlertClose } from "../../app_services/AlertService";
import { get_main_user_data } from '../../page_action/app_main';
import BackgroundMusic from '../wheel_game_play/BackgroundMusic';

export default function AppMain({ url_schema }) {
    const [isRady, setIsRadey] = useState(false)
    const { site_title, set_site_title, setIsPlaying, setHasInteracted } = useContext(Context);
    const { userData, setUserData, menuShow, setMenuShow, lineData, setLineData } = useContext(Context);
    const navigation = useNavigate()
    const location = useLocation()

    useEffect(() => {
        setIsRadey(true)

    }, [])

    useEffect(() => {
        set_site_title("MK-Rewards")
        GetLineProfile()
    }, [])

    useEffect(() => {
        // console.log(userData)
        if (!userData) {
            if (location.pathname !== '/authentication') {
                window.location.href = '/mk-rewards/authentication'
            }
        } else {
            navigation('/home')
        }
        //eslint-disable-next-line
    }, [userData])

    useEffect(() => {
        if (userData) {
            if (location.pathname === '/authentication') {
                navigation('/home')
            }
        }
        //eslint-disable-next-line
    }, [location, userData])

    useEffect(() => {
        if (url_schema) {
            // console.log(url_schema)
            if (url_schema.filter(item => item.path === `/${location.pathname.split('/')[1]}`)[0]) {
                set_site_title("MK-Rewards | " + url_schema.filter(item => item.path === `/${location.pathname.split('/')[1]}`)[0].title)
            } else {
                //set_site_title("MK-Rewards")
            }
        }
        //eslint-disable-next-line
    }, [location])

    const GetLineProfile = async () => {
        try {

            try {
                Loading('รอสักครู่')
                await liff.init({ liffId: `2006744943-OkNedKGV` });
                // console.log('isInClient', liff.isInClient())
                // console.log('isLoggedIn', liff.isLoggedIn())
                if (liff.isLoggedIn()) {
                    let getProfile = await liff.getProfile();
                    setLineData(getProfile)
                    // console.log(JSON.stringify(getProfile, null, 2))
                    await get_main_user_data({ line_userid: getProfile.userId }, navigation, setUserData)
                    AlertClose()
                    setIsRadey(true)
                    return true;
                } else {
                    AlertClose()
                    liff.login();
                }
            } catch (err) {
                AlertClose()
                console.log('เกิดข้อผิดพลาดในระหว่างการเริ่มต้น LIFF หรือการเข้าสู่ระบบ:', err);
            }
        } catch (err) {
            AlertClose()
            console.log('เกิดข้อผิดพลาดในระหว่างการเริ่มต้น LIFF หรือการเข้าสู่ระบบ:', err);
        }
    }




    return (
        <div className='app'>

            <Helmet>
                <title>{site_title}</title>
            </Helmet>

            <div className="" style={{ display: isRady ? '' : 'none' }}>
                {location.pathname !== '/authentication' ?
                    <BackgroundMusic audioUrl="https://www.mkmedical.online:444/image_wheel_game/Mingle%20Game%20Song.mp3" />
                    : null}

                <Outlet />
            </div>
        </div>
    )
}
